





















































import { Anagrafica } from '@/models/anagrafica.model';
import { Page } from '@/models/page.model';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component({})
export default class StpTable extends Vue {

	@Prop() data!: Anagrafica[];
	@Prop() page!: Page;
	@Prop() loading!: boolean;

	firstload: boolean = true;

	@Watch('data')
	onDataChange() {
		this.firstload = false;
	}

	onPageChange(page: number) {
		this.$emit('page', page);
	}
}
